import React from "react"
import { motion } from "framer-motion"

const CheckboxGroup = ({ title, options, onChange }) => {
  return (
    <motion.div
      className="mb-6 flex flex-col gap-[19px] relative"
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.4 }}
    >
      <span className="text-app-content font-medium text-lg">{title}</span>

      <div className="flex flex-col gap-3">
        {options.map((option) => (
          <label
            key={option.value}
            className="flex items-center justify-between cursor-pointer group"
          >
            <div className="flex items-center gap-2">
              <div
                onClick={() => onChange(option.value)}
                className={`w-4 h-4 border rounded flex items-center justify-center transition-colors cursor-pointer
                  ${
                    option.checked
                      ? "bg-app-base-strong border-app-base-strong"
                      : "border-gray-300 group-hover:border-gray-400"
                  }`}
              >
                {option.checked && (
                  <svg className="w-3 h-3 text-white" viewBox="0 0 12 12" fill="none">
                    <path
                      d="M2 6l3 3 5-5"
                      stroke="currentColor"
                      strokeWidth="1.5"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                  </svg>
                )}
              </div>
              <span className="text-sm text-app-content">{option.label}</span>
            </div>
            {option.count !== undefined && (
              <span className="text-sm font-medium text-app-content-subtle">{option.count}</span>
            )}
          </label>
        ))}
      </div>
    </motion.div>
  )
}

export default CheckboxGroup
